import { render, staticRenderFns } from "./KycTable.vue?vue&type=template&id=3110248a&scoped=true&"
import script from "./KycTable.vue?vue&type=script&lang=js&"
export * from "./KycTable.vue?vue&type=script&lang=js&"
import style0 from "./KycTable.vue?vue&type=style&index=0&id=3110248a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110248a",
  null
  
)

export default component.exports